import { ActionReducerMap } from '@ngrx/store';
import { AppState } from '../app.state';
import { booksReducer } from './books.reducer';

export const reducers: ActionReducerMap<AppState> = {
  booksState: booksReducer,
};
